<template>
  <div
    class="flex relative flex-col dark:text-white m-auto py-8 max-w-lg w-full"
    :class="context.wrapperClass"
  >
    <button class="max-md:hidden" @click="context.close">
      <IconX
        class="absolute right-4 md:-right-2 -top-2 translate-x-full text-white -translate-y-full size-6"
      />
    </button>

    <div class="space-y-4">
      <UIHeading title="Правила комментирования" tag="2" />

      <LoadingView class="min-h-[200px]" :loading="isLoading">
        <div
          v-if="content"
          class="prose dark:prose-invert max-w-full"
          v-html="content"
        />
        <p v-else class="text-black-500 dark:text-black-400">
          Правила комментирования не заданы
        </p>
      </LoadingView>

      <UIButton
        title="Понятно"
        class="w-full rounded-md"
        @click="context.close"
      />
    </div>
  </div>
</template>

<script setup>
import { inject, onMounted, ref } from 'vue'

import { IconX } from '@tabler/icons-vue'

import LoadingView from '@/components/loading/LoadingView.vue'
import UIButton from '@/components/ui/UIButton.vue'
import UIHeading from '@/components/ui/UIHeading.vue'

defineProps({
  context: {
    type: Object,
    default: () => ({}),
  },
})

const http = inject('http')
const isLoading = ref(true)
const content = ref('')

onMounted(() => {
  http('/comments/rules')
    .then(({ resource }) => {
      content.value = resource
    })
    .finally(() => {
      isLoading.value = false
    })
})
</script>
